import {CanActivateFn, Router} from '@angular/router';
import {inject} from '@angular/core';
import {AppInitialization} from '@core/services';
import {CompanyStateService} from '@core/states';

export const employeeRouteGuard: CanActivateFn = async (route, state) => {
  const router = inject(Router);
  const companyState = inject(CompanyStateService);
  const appInitialization = inject(AppInitialization);

  await appInitialization.checkInitialization();

  const membership = companyState.membership();
  if (!companyState.isEmployeeMembership(membership)) {
    return true;
  }

  return state.url === '/dashboard'
    || state.url === '/dashboard/notifications'
    || state.url === '/dashboard/surveys'
    || state.url.startsWith('/dashboard/surveys/pending/')
    ? true
    : router.parseUrl('/dashboard');
};
